export default __webpack_public_path__ + "static/media/logosmall.90a18bc1.png";